import React from 'react'
import { type IUser } from '../../../models/User'
import { Box, Typography, useTheme } from '@mui/material'
import { black } from '../../../colors'
import { StudentEnrollmentListItem } from './StudentEnrollmentListItem'

interface StudentListSectionProps {
  title: string
  students: IUser[]
  enrolled?: boolean
  onAction: (userId: string) => void
  readOnly?: boolean
  sectionId?: string
  notEnrolledSection?: boolean
  showAllInstructorForNewlyAdded?: boolean
  newlyEnrolled?: IUser[]
  slotId?: string
  sectionStatus?: string
}

export const StudentListSection: React.FC<StudentListSectionProps> = ({
  title,
  students,
  enrolled = false,
  onAction,
  readOnly,
  sectionId,
  notEnrolledSection = false,
  showAllInstructorForNewlyAdded = false,
  newlyEnrolled = [],
  slotId,
  sectionStatus
}) => {
  const theme = useTheme()
  const displayedStudents = students?.slice(0, 20) || []
  return (
    <>
      <Typography sx={{ mt: 3 }} variant='h5' fontSize={theme.spacing(4)} color={black[100]}>
        {title} ({students?.length >= 20 ? '20+' : students?.length || 0})
      </Typography>
      <Box>
        {displayedStudents?.map((student: IUser, index: number) => {
          const isNewlyAdded = showAllInstructorForNewlyAdded && newlyEnrolled.some(newlyEnrolledStudent => newlyEnrolledStudent.userId === student.userId)
          return (
            <StudentEnrollmentListItem
              enrolled={enrolled}
              key={student?.userId ?? `error-${index}`}
              index={index}
              handlePressed={() => { onAction(student?.userId) }}
              readOnly={readOnly}
              student={student}
              sectionId={sectionId}
              notEnrolledSection={notEnrolledSection || isNewlyAdded}
              slotId={slotId}
              sectionStatus={sectionStatus}
            />
          )
        })}
      </Box>
    </>
  )
}
